
        import type { TemplateResult, TemplateRootPropsForTag } from 'Components/types';
type relatedItemsRTRootProps = TemplateRootPropsForTag<'div'>;
import { createElement as _createElement } from 'preact';
import { map as _map } from 'Utils/array';
import _translate from 'Utils/translate';
export default function relatedItemsRT(): TemplateResult<relatedItemsRTRootProps> {
    function repeatItems1(discountMode, isHasModalDialog, items, itemsIndex) {
        return [items(function () {
                function repeatBadge1(badge, badgeIndex) {
                    return _createElement('span', {
                        'className': 'product-label product-label--custom1 cm_badge cm_badge__' + this.toKebabCase(badge),
                        'key': badge
                    }, '\n      ', badge, '\n    ');
                }
                function repeatI2(i, iIndex) {
                    return _createElement('span', {
                        'key': i,
                        'className': 'cm_star cm_star__' + (!(this.review_average - i) || this.review_average - i < 0.25 ? 'empty' : this.review_average - i < 0.75 ? 'half' : 'full')
                    });
                }
                function mergeProps(inline, external) {
                    var res = Object.assign({}, inline, external);
                    if (inline.hasOwnProperty('style')) {
                        res.style = _.defaults(res.style, inline.style);
                    }
                    if (inline.hasOwnProperty('className') && external.hasOwnProperty('className')) {
                        res.className = external.className + ' ' + inline.className;
                    }
                    return res;
                }
                function scopeProduct4() {
                    var product = this.productData ?? this;
                    return [product.is_autosync_allowed ? _createElement('button', {
                            'className': 'cm_view-on-vehicle-btn cm_btn button button--small button--secondary',
                            'onClick': () => window.Convermax.openAutoSyncDialog(product.autosync_id, product.autosync_mpn, product.FitmentType?.includes('Tire')),
                            'type': 'button',
                            'key': '53181'
                        }, '\n    ', _translate(`view_product_on_vehicle`), '\n  ') : null];
                }
                return _createElement('div', { 'className': 'product-item product-item--' + (window.location.pathname.includes('/products/') ? 'vertical' : this.view) + ' 1/3--tablet-and-up 1/4--desk' + (this.is_promotional_item ? ' cm_promotion' : '') }, _createElement.apply(this, [
                    'div',
                    { 'className': 'product-item__label-list' },
                    this.on_sale && discountMode !== 'percentage' ? _createElement('span', {
                        'className': 'product-label product-label--on-sale',
                        'key': '279'
                    }, '\n      Save ', this.formatPrice(this.compare_at_price - this.price), '\n    ') : null,
                    this.on_sale && discountMode === 'percentage' ? _createElement('span', {
                        'className': 'product-label product-label--on-sale',
                        'key': '485'
                    }, '\n      Save ', Math.round((this.compare_at_price - this.price) * 100 / this.compare_at_price), '%\n    ') : null,
                    this._badges ? _map(this._badges, repeatBadge1.bind(this)) : null
                ]), _createElement('a', {
                    'href': this.url,
                    'className': 'product-item__image-wrapper' + (this.image2 ? ' product-item__image-wrapper--with-secondary' : '')
                }, _createElement('div', {
                    'className': 'aspect-ratio aspect-ratio--square',
                    'style': { paddingBottom: '100%' }
                }, _createElement('img', {
                    'className': 'product-item__primary-image image--fade-in lazyautosizes lazyloaded',
                    'src': this.imageOrDefault(this.resizeImage(this.image)),
                    'alt': this.removeHTML(this.title),
                    'onError': this.onImageError
                }), this.image2 ? _createElement('img', {
                    'className': 'product-item__secondary-image image--fade-in lazyautosizes lazyloaded',
                    'src': this.imageOrDefault(this.resizeImage(this.image2)),
                    'alt': this.removeHTML(this.title),
                    'onError': e => this.onImageError(e, 'image2'),
                    'key': '1368'
                }) : null)), _createElement('div', { 'className': 'product-item__info' }, _createElement('div', { 'className': 'product-item__info-inner' }, [this.review_count ? _createElement.apply(this, [
                        'div',
                        {
                            'className': 'cm_review-stars',
                            'key': '17310'
                        },
                        _map([
                            0,
                            1,
                            2,
                            3,
                            4
                        ], repeatI2.bind(this)),
                        _createElement('span', { 'className': 'cm_review-count' }, '(', this.review_count, ')')
                    ]) : null], this.vendor && this.vendor_url ? _createElement('a', mergeProps({
                    'href': this.vendor_url,
                    'className': 'product-item__vendor link',
                    'key': '2134'
                }, { dangerouslySetInnerHTML: { __html: typeof this.vendor === 'undefined' ? '' : this.vendor } })) : null, _createElement('a', mergeProps({
                    'href': this.url,
                    'className': 'product-item__title text--strong link'
                }, { dangerouslySetInnerHTML: { __html: typeof this.breakWordOnSlash(this.title) === 'undefined' ? '' : this.breakWordOnSlash(this.title) } })), _createElement('div', { 'className': 'product-item__price-list price-list' }, this.on_sale ? [
                    _createElement('span', {
                        'className': 'price price--highlight',
                        'key': '26821'
                    }, '\n            ', this.price_varies ? `${ _translate(`price_from`) } ` : '', this.formatPrice(this.min_price || this.price), '\n          '),
                    _createElement('span', {
                        'className': 'price price--compare',
                        'key': '26823'
                    }, this.formatPrice(this.compare_at_price))
                ] : null, !this.on_sale ? _createElement('span', {
                    'className': 'price',
                    'key': '3041'
                }, '\n          ', this.price_varies ? `${ _translate(`price_from`) } ` : '', this.formatPrice(this.min_price || this.price), '\n        ') : null, this.set_qty ? _createElement('div', {
                    'className': 'price-item--set',
                    'key': '3241'
                }, '\n          ', _translate(`product_set_of`, {  count: this.set_qty  }), ': ', this.formatPrice(this.price * this.set_qty), '\n        ') : null), this.price ? _createElement('p', {
                    'className': 'affirm-as-low-as',
                    'data-amount': this.price * 100,
                    'data-affirm-type': 'logo',
                    'data-affirm-color': 'blue',
                    'key': '3440'
                }) : null), _createElement('form', {
                    'method': 'post',
                    'action': '/cart/add',
                    'acceptCharset': 'UTF-8',
                    'className': 'product-item__action-list button-stack',
                    'encType': 'multipart/form-data'
                }, _createElement('input', {
                    'type': 'hidden',
                    'name': 'quantity',
                    'value': this.set_qty || 1
                }), _createElement('input', {
                    'type': 'hidden',
                    'name': 'id',
                    'value': this.variant_ids
                }), this.fitsTheVehicle && !window.Convermax.config?.hideVerifyOnCartItems ? _createElement('input', {
                    'type': 'hidden',
                    'name': 'properties[Fitment]',
                    'value': this.getVerifyFitmentOrderNotes(this.fitsTheVehicle),
                    'key': '3870'
                }) : null, this.out_of_stock ? _createElement('button', {
                    'className': 'product-item__action-button button button--small button--disabled',
                    'disabled': true,
                    'key': '4077'
                }, '\n        ', _translate(`product_out_of_stock`), '\n      ') : null, !this.out_of_stock && this.variant_ids.length === 1 && (!this.ProductScope || this.ProductScope === 'child') ? _createElement('button', {
                    'type': 'submit',
                    'className': 'product-item__action-button button button--small button--primary',
                    'data-action': 'add-to-cart',
                    'key': '4266'
                }, '\n        ', _translate(`product_add_to_cart`), this.set_qty ? ` ${ _translate(`product_set_of`, {  count: this.set_qty  }) }` : '', '\n      ') : null, !this.out_of_stock && this.variant_ids.length > 1 || this.ProductScope === 'master' ? _createElement('a', {
                    'href': this.url,
                    'className': 'product-item__action-button button button--small button--primary',
                    'key': '4694'
                }, '\n        ', _translate(`product_select_options`), '\n      ') : null, isHasModalDialog ? _createElement('button', {
                    'type': 'button',
                    'className': 'product-item__action-button button button--small button--ternary hidden-phone',
                    'data-action': 'open-modal',
                    'data-secondary-action': 'open-quick-view',
                    'aria-controls': 'modal-quick-view',
                    'data-product-url': this.url,
                    'key': '4968'
                }, '\n        ', _translate(`product_quick_view`), '\n      ') : null), [scopeProduct4.apply(this, [])]));
            }, { count: undefined })];
    }
    function scopeDiscountModeIsHasModalDialog2() {
        var discountMode = window.theme?.discountMode;
        var isHasModalDialog = window.document.querySelector('.modal__dialog');
        return _createElement.apply(this, [
            'div',
            { 'className': 'cm_related-products-list cmRepeater_items' },
            _map(this.items, repeatItems1.bind(this, discountMode, isHasModalDialog))
        ]);
    }
    return _createElement('div', { 'className': 'cm_related-products' }, _createElement('div', { 'className': 'section__header cm_related-products-title-container' }, _createElement('h2', { 'className': 'section__title heading h3 cm_related-products-title' }, _translate(`related_items_title`))), scopeDiscountModeIsHasModalDialog2.apply(this, []));
}
        export const componentNames = []